import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from 'components/App';
import { AuthProvider } from 'components/AuthContext';
import { restoreAuthFromCookie } from 'utils/authStorage';
import './index.css';

// Restore authentication data from cookies if localStorage was cleared
restoreAuthFromCookie();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <Router>
                <App />
            </Router>
        </AuthProvider>
    </React.StrictMode>
);
